import React from 'react';
import packageJson from '../../../package.json';

const { noiseDeskVersion } = packageJson;

export const ProductVersion = (): JSX.Element => (
  <div className="product-version">
    Version {noiseDeskVersion}
  </div>
);